export default "/_next/static/images/rachel-sprague-eb23e7de8b7e9701238c39249b8414bc.png";